export class Search {
  query: string = null;
  duration: number = 0;
  filters: SearchFilter[] = [];
}

export class SearchFilter {
  key: string;
  label: string;
  type: string;
  value: any;
  lookupKey: string;
}
